import { NgModule } from '@angular/core';

import { TimeAgoPipe } from './time-ago/time-ago.pipe';
import { SortCodesPipe } from './sort-code/sort-codes.pipe';
import { SortColorPipe } from './sort-color/sort-color.pipe';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { CloudinaryImgPipe } from './cloudinary-img/cloudinary-img.pipe';
@NgModule({
  declarations: [
    TimeAgoPipe,
    SortCodesPipe,
    SortColorPipe,
    CapitalizePipe,
    CloudinaryImgPipe,
  ],
  imports: [],
  exports: [
    TimeAgoPipe,
    SortCodesPipe,
    SortColorPipe,
    CapitalizePipe,
    CloudinaryImgPipe,
  ],
})
export class PipesModule {}
